export default {
    NEW_REGISTRATION_REQUEST: 'NEW_REGISTRATION_REQUEST',
    NEW_REGISTRATION_SUCCESS: 'NEW_REGISTRATION_SUCCESS',
    NEW_REGISTRATION_FAILURE: 'NEW_REGISTRATION_FAILURE',
    REGISTER_GMAIL_REQUEST: 'REGISTER_GMAIL_REQUEST',
    REGISTER_GMAIL_SUCCESS: 'REGISTER_GMAIL_SUCCESS',
    REGISTER_GMAIL_FAILURE: 'REGISTER_GMAIL_FAILURE',
};